import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    headerEntryInfo: {
      marginBottom: 10,
      "&.details": {
        padding: "10px 20px 10px 16px",
        marginBottom: 0,
        [theme.breakpoints.down(Breakpoints.SS_320)]: {
          padding: "11px 12px 11px 12px"
        }
      }
    },
    row: {
      display: "flex",
      justifyContent: "space-between"
    },
    date: {
      color: "#2d2d2d",
      fontWeight: 700,
      "&.details": {
        fontSize: 16
      }
    },
    extraInfo: {
      alignSelf: "center",
      fontSize: 12,
      color: primary.dark,
      "&.details": {
        fontSize: 14
      }
    },
    facilityName: {
      textTransform: "capitalize",
      color: primary.dark,
      fontSize: 12
    }
  };
});
